/* MODULE: MARTAKIDS Product Page — vanilla JS, no dependencies */
(function () {
  'use strict';

  /* MODULE: DESKTOP GALLERY THUMBNAILS */
  function initGallery() {
    var thumbs = document.querySelectorAll('.mk-gallery__thumb');
    var mainImg = document.querySelector('.mk-gallery__main');
    if (!mainImg) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImg.src = this.dataset.src;
        if (this.dataset.srcset) mainImg.srcset = this.dataset.srcset;
        thumbs.forEach(function (t) { t.classList.remove('mk-gallery__thumb--active'); });
        this.classList.add('mk-gallery__thumb--active');
      });
      thumb.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }

  /* MODULE: MOBILE GALLERY SCROLL DOTS */
  function initMobileDots() {
    var slides = document.querySelector('.mk-gallery__slides');
    var dots = document.querySelectorAll('.mk-gallery__dot');
    if (!slides || !dots.length) return;
    slides.addEventListener('scroll', function () {
      var idx = Math.round(slides.scrollLeft / (slides.offsetWidth || 1));
      dots.forEach(function (d, i) {
        d.classList.toggle('mk-gallery__dot--active', i === idx);
      });
    }, { passive: true });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        slides.scrollTo({ left: i * slides.offsetWidth, behavior: 'smooth' });
      });
    });
  }

  /* MODULE: VARIANT SELECTOR */
  function initVariants() {
    var infoWrap = document.querySelector('.mk-product-info-wrap');
    if (!infoWrap) return;
    var variantInput = document.querySelector('.mk-product-form [name="id"]');
    var priceEl = infoWrap.querySelector('.mk-price__current');
    var compareEl = infoWrap.querySelector('.mk-price__compare');
    var savingsEl = infoWrap.querySelector('.mk-price__savings');
    var submitBtn = document.querySelector('.mk-product-form__submit');
    var stickyPrice = document.querySelector('.mk-sticky-bar__price');
    var unavailableText = submitBtn ? submitBtn.dataset.unavailable : 'Niedost�pny';
    var addText = submitBtn ? submitBtn.dataset.add : 'Dodaj do koszyka';

    var variantsData = [];
    var variantsScript = document.querySelector('#mk-variants-data');
    if (variantsScript) {
      try { variantsData = JSON.parse(variantsScript.textContent); } catch (e) { }
    }

    var selectedOptions = {};
    var optionBtns = document.querySelectorAll('.mk-variants__option-btn, .mk-variants__swatch');

    // Seed selected options from initially active buttons
    optionBtns.forEach(function (btn) {
      if (btn.classList.contains('mk-variants__option-btn--active') || btn.classList.contains('mk-variants__swatch--active')) {
        selectedOptions[btn.dataset.option] = btn.dataset.value;
      }
    });

    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optionName = this.dataset.option;
        var optionValue = this.dataset.value;
        selectedOptions[optionName] = optionValue;

        document.querySelectorAll('.mk-variants__option-btn[data-option="' + CSS.escape(optionName) + '"], .mk-variants__swatch[data-option="' + CSS.escape(optionName) + '"]').forEach(function (b) {
          b.classList.toggle('mk-variants__option-btn--active', b.dataset.value === optionValue);
          b.classList.toggle('mk-variants__swatch--active', b.dataset.value === optionValue);
        });

        var match = findVariant(variantsData, selectedOptions);
        if (!match) return;

        if (variantInput) variantInput.value = match.id;

        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = formatMoney(match.compare_at_price);
            compareEl.style.display = '';
            if (savingsEl) {
              savingsEl.textContent = 'Oszczędzasz ' + formatMoney(match.compare_at_price - match.price);
              savingsEl.style.display = '';
            }
          } else {
            compareEl.style.display = 'none';
            if (savingsEl) savingsEl.style.display = 'none';
          }
        }
        if (stickyPrice) stickyPrice.textContent = formatMoney(match.price);

        if (submitBtn) {
          submitBtn.disabled = !match.available;
          submitBtn.textContent = match.available ? addText : unavailableText;
        }

        if (match.featured_image) {
          var mainImg = document.querySelector('.mk-gallery__main');
          if (mainImg) mainImg.src = match.featured_image.src;
          var slides = document.querySelector('.mk-gallery__slides');
          if (slides) {
            var idx = (match.featured_image.position || 1) - 1;
            slides.scrollTo({ left: idx * slides.offsetWidth, behavior: 'smooth' });
          }
        }
      });
    });
  }

  function findVariant(variants, selected) {
    return variants.find(function (v) {
      return v.option_names.every(function (name, i) {
        return !selected[name] || selected[name] === v.options[i];
      });
    }) || null;
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zl ';
  }

  /* MODULE: QUANTITY SELECTOR */
  function initQty() {
    var minus = document.querySelector('.mk-qty__btn--minus');
    var plus = document.querySelector('.mk-qty__btn--plus');
    var input = document.querySelector('.mk-qty__input');
    if (!minus || !plus || !input) return;
    minus.addEventListener('click', function () {
      var val = parseInt(input.value, 10);
      if (val > 1) input.value = val - 1;
    });
    plus.addEventListener('click', function () {
      var val = parseInt(input.value, 10);
      if (val < 99) input.value = val + 1;
    });
    input.addEventListener('change', function () {
      var val = parseInt(this.value, 10);
      if (isNaN(val) || val < 1) this.value = 1;
      if (val > 99) this.value = 99;
    });
  }

  /* MODULE: ADD TO CART – AJAX (uses the theme's native cart drawer/notification) */
  function initAddToCart() {
    var form = document.querySelector('.mk-product-form');
    if (!form) return;

    // The theme's cart UI element (drawer in drawer mode, notification otherwise).
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    // Add-to-cart URL provided by the theme; fall back to the default if missing.
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.mk-product-form__submit');
      var qtyInput = form.querySelector('.mk-qty__input');
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      btn.classList.add('mk-product-form__submit--loading');
      btn.disabled = true;

      // Build the request the same way the theme's product-form.js does, so the
      // cart drawer re-renders correctly after adding.
      var formData = new FormData(form);
      formData.set('quantity', quantity);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          btn.classList.remove('mk-product-form__submit--loading');
          btn.disabled = false;

          // An error response carries a `status` field (e.g. sold out).
          if (response.status) return;

          // Refresh the cart contents (icon count + drawer markup) WITHOUT opening
          // the drawer. We update the same sections the theme would, but skip the
          // open() that cart.renderContents() triggers.
          if (cart && response.sections) {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            updateCartSections(cart, response.sections);
          } else if (!cart) {
            // No cart drawer/notification on the page — go to the cart page.
            window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
            return;
          }

          // Refresh the free-shipping bar from the live cart. We re-fetch /cart.js
          // because the add response (with `sections`) returns the line item, not
          // the whole cart, so it has no reliable total_price.
          refreshFreeShipBar();

          showAddedFeedback(btn);
        })
        .catch(function () {
          btn.classList.remove('mk-product-form__submit--loading');
          btn.disabled = false;
        });
    });
  }

  /* Update cart icon + drawer markup from an add-to-cart response, without opening it. */
  function updateCartSections(cart, sections) {
    if (typeof cart.getSectionsToRender !== 'function') return;
    cart.getSectionsToRender().forEach(function (section) {
      var el = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!el || !sections[section.id]) return;
      var parsed = new DOMParser().parseFromString(sections[section.id], 'text/html');
      var src = parsed.querySelector(section.selector || '.shopify-section');
      if (src) el.innerHTML = src.innerHTML;
    });
  }

  /* Briefly flip the submit button to a confirmation, then restore it. */
  function showAddedFeedback(btn) {
    if (!btn || btn.dataset.mkAdding === '1') return;
    var original = btn.dataset.add || btn.textContent;
    btn.dataset.mkAdding = '1';
    btn.classList.add('mk-product-form__submit--added');
    btn.textContent = 'Dodano ✓';
    setTimeout(function () {
      btn.classList.remove('mk-product-form__submit--added');
      btn.textContent = original;
      btn.dataset.mkAdding = '0';
    }, 1800);
  }

  /* MODULE: FREE SHIPPING BAR — recompute from a cart total (in cents) */
  function formatZl(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }
  function updateFreeShipBar(totalCents) {
    var bar = document.querySelector('.mk-freeship');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold, 10);
    if (!threshold || isNaN(threshold)) return;
    var label = bar.querySelector('.mk-freeship__label');
    var fill = bar.querySelector('.mk-freeship__fill');

    var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
    if (fill) fill.style.width = pct + '%';

    if (label) {
      if (totalCents >= threshold) {
        label.textContent = bar.dataset.msgSuccess || '';
      } else {
        var remaining = formatZl(threshold - totalCents);
        label.textContent = (bar.dataset.msgProgress || '').replace('[kwota]', remaining);
      }
    }
  }
  /* Fetch the live cart total and refresh the bar. Used on load AND after each add. */
  function refreshFreeShipBar() {
    if (!document.querySelector('.mk-freeship')) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateFreeShipBar(cart.total_price); })
      .catch(function () {});
  }
  function initFreeShipBar() { refreshFreeShipBar(); }

  /* MODULE: BUY NOW */
  function initBuyNow() {
    var btn = document.querySelector('.mk-btn-buy-now');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var variantId = document.querySelector('.mk-product-form [name="id"]').value;
      var qtyInput = document.querySelector('.mk-qty__input');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      window.location.href = '/cart/' + variantId + ':' + qty + '?checkout';
    });
  }

  /* MODULE: WISHLIST (localStorage) */
  function initWishlist() {
    var btn = document.querySelector('.mk-wishlist-btn');
    if (!btn) return;
    var productId = btn.dataset.productId;
    var getList = function () { return JSON.parse(localStorage.getItem('mk_wishlist') || '[]'); };
    if (getList().indexOf(productId) !== -1) btn.classList.add('mk-wishlist-btn--active');
    btn.addEventListener('click', function () {
      var list = getList();
      var idx = list.indexOf(productId);
      if (idx === -1) { list.push(productId); btn.classList.add('mk-wishlist-btn--active'); }
      else { list.splice(idx, 1); btn.classList.remove('mk-wishlist-btn--active'); }
      localStorage.setItem('mk_wishlist', JSON.stringify(list));
    });
  }

  /* MODULE: ACCORDIONS (supports multiple accordion blocks on the page) */
  function initAccordions() {
    var containers = document.querySelectorAll('.mk-accordion');
    if (!containers.length) return;

    containers.forEach(function (container) {
      var oneAtATime = container.dataset.oneAtATime === 'true';
      var triggers = container.querySelectorAll('.mk-accordion__trigger');

      triggers.forEach(function (trigger) {
        // Set initial max-height for open accordions
        if (trigger.getAttribute('aria-expanded') === 'true') {
          var body = trigger.nextElementSibling;
          body.style.maxHeight = body.scrollHeight + 'px';
        }
        trigger.addEventListener('click', function () {
          var isOpen = this.getAttribute('aria-expanded') === 'true';
          if (oneAtATime && !isOpen) {
            triggers.forEach(function (t) {
              t.setAttribute('aria-expanded', 'false');
              var b = t.nextElementSibling;
              b.classList.remove('mk-accordion__body--open');
              b.style.maxHeight = '0';
            });
          }
          this.setAttribute('aria-expanded', String(!isOpen));
          var body = this.nextElementSibling;
          if (!isOpen) {
            body.classList.add('mk-accordion__body--open');
            body.style.maxHeight = body.scrollHeight + 'px';
          } else {
            body.classList.remove('mk-accordion__body--open');
            body.style.maxHeight = '0';
          }
        });
      });
    });
  }

  /* MODULE: SHARE BUTTONS */
  function initShare() {
    var copyBtn = document.querySelector('.mk-share__btn--copy');
    var fbBtn = document.querySelector('.mk-share__btn--fb');
    var toast = document.querySelector('.mk-share__toast');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        navigator.clipboard.writeText(window.location.href).then(function () {
          if (toast) {
            toast.classList.add('mk-share__toast--visible');
            setTimeout(function () { toast.classList.remove('mk-share__toast--visible'); }, 2000);
          }
        }).catch(function () {
          var ta = document.createElement('textarea');
          ta.value = window.location.href;
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          if (toast) {
            toast.classList.add('mk-share__toast--visible');
            setTimeout(function () { toast.classList.remove('mk-share__toast--visible'); }, 2000);
          }
        });
      });
    }
    if (fbBtn) {
      fbBtn.addEventListener('click', function () {
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(window.location.href), '_blank', 'width=600,height=400');
      });
    }
  }

  /* MODULE: STICKY BAR (mobile) */
  function initStickyBar() {
    var mainCta = document.querySelector('.mk-product-form__submit');
    var stickyBar = document.querySelector('.mk-sticky-bar');
    var stickyBtn = document.querySelector('.mk-sticky-bar__btn');
    if (!mainCta || !stickyBar) return;
    if (!('IntersectionObserver' in window)) {
      stickyBar.classList.remove('mk-sticky-bar--hidden');
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('mk-sticky-bar--hidden', entry.isIntersecting);
      });
    }, { threshold: 0.1 });
    observer.observe(mainCta);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.querySelector('.mk-product-form');
        if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }
  }

  /* MODULE: REVIEWS – show more */
  function initReviews() {
    var showMoreBtn = document.querySelector('.mk-reviews__show-more');
    if (!showMoreBtn) return;
    var perPage = parseInt(showMoreBtn.dataset.perPage, 10) || 4;
    var cards = document.querySelectorAll('.mk-review-card');
    var visible = perPage;

    cards.forEach(function (card, i) { if (i >= visible) card.style.display = 'none'; });
    if (cards.length <= perPage) showMoreBtn.style.display = 'none';

    showMoreBtn.addEventListener('click', function () {
      visible += perPage;
      cards.forEach(function (card, i) { if (i < visible) card.style.display = ''; });
      if (visible >= cards.length) showMoreBtn.style.display = 'none';
    });
  }

  /* INIT */
  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
    initMobileDots();
    initVariants();
    initQty();
    initAddToCart();
    initBuyNow();
    initWishlist();
    initAccordions();
    initShare();
    initStickyBar();
    initReviews();
    initFreeShipBar();
  });
})();
